import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Printer, Megaphone, Users, BarChart3, Share2, CheckCircle2 } from "lucide-react";
import { Seo } from "../components/Seo";

const SITE_URL = "https://flexlines.store";
const ADVERTISE_URL = `${SITE_URL}/advertise`;

const PERKS = [
    { icon: Users, label: "Reach real, verified Flex Line members" },
    { icon: BarChart3, label: "See your views & clicks in real time" },
    { icon: Share2, label: "Share your deal link on Facebook, Instagram & your bio" },
    { icon: CheckCircle2, label: "Go live in minutes — approved by our team" },
];

export default function AdsPoster() {
    return (
        <div className="min-h-screen bg-zinc-100 py-8 px-4 print:bg-white print:p-0" data-testid="ads-poster-page">
            <Seo
                title="Advertise on Flex Line — Reach Real Local Customers"
                description="Promote your business to Flex Line members. Sponsored cards, a public Deals directory, and inbox placements from $4.90/mo. Scan to start at flexlines.store/advertise."
                path="/ads-poster"
                image="https://flexlines.store/og-advertise.png"
            />
            {/* Print bar (hidden on print) */}
            <div className="max-w-[820px] mx-auto mb-6 flex items-center justify-between print:hidden">
                <p className="text-sm text-zinc-600">Advertiser poster — print or save as PDF (Letter / A4).</p>
                <button
                    onClick={() => window.print()}
                    data-testid="ads-poster-print-btn"
                    className="h-10 px-5 bg-[#4C1D95] text-white rounded-sm text-sm flex items-center gap-2 hover:bg-[#4C1D95]/90"
                >
                    <Printer className="w-4 h-4" /> Print / Save as PDF
                </button>
            </div>

            {/* Poster sheet */}
            <div className="max-w-[820px] mx-auto bg-white border border-zinc-200 print:border-0 aspect-[1/1.294] flex flex-col" data-testid="ads-poster-sheet">
                <div className="flex-1 flex flex-col px-12 py-14">
                    <div className="flex items-center justify-between">
                        <img src="/flexline-wordmark.svg" alt="Flex Line" className="h-9 w-auto" />
                        <span className="font-mono text-[11px] uppercase tracking-wider text-emerald-deep flex items-center gap-1.5">
                            <Megaphone className="w-3.5 h-3.5" /> Advertise
                        </span>
                    </div>

                    <div className="mt-14">
                        <p className="font-mono text-[12px] uppercase tracking-[0.2em] text-[#D97706]">For local & online businesses</p>
                        <h1 className="font-display text-5xl sm:text-6xl font-light leading-[1.05] tracking-tight mt-4">
                            Put your business in front of <span className="font-serif-italic text-[#4C1D95]">real customers.</span>
                        </h1>
                        <p className="text-lg text-zinc-600 mt-5 max-w-xl">
                            Advertise on Flex Line — the second-phone-number app thousands trust. Get a sponsored card on the
                            member dashboard, a listing in our public Deals directory, or an inbox placement.
                        </p>
                    </div>

                    <ul className="mt-10 grid grid-cols-2 gap-x-8 gap-y-5 max-w-xl">
                        {PERKS.map(({ icon: Icon, label }) => (
                            <li key={label} className="flex items-start gap-3">
                                <Icon className="w-5 h-5 text-emerald-deep shrink-0 mt-0.5" />
                                <span className="text-[15px] text-zinc-800">{label}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-auto pt-12 flex items-end justify-between gap-8">
                        <div>
                            <p className="font-mono text-[11px] uppercase tracking-wider text-zinc-500">Plans from</p>
                            <div className="font-display text-5xl font-light tracking-tight mt-1">$4.90<span className="text-2xl text-zinc-500"> / 3 days</span></div>
                            <p className="text-sm text-zinc-500 mt-1">or $29.99 one-time for 30 days · cancel anytime</p>
                            <p className="text-[15px] font-medium text-[#4C1D95] mt-4">Get started → flexlines.store/advertise</p>
                        </div>
                        <div className="text-center shrink-0">
                            <div className="p-3 bg-white border border-zinc-200 rounded-sm">
                                <QRCodeSVG value={ADVERTISE_URL} size={132} fgColor="#4C1D95" level="M" />
                            </div>
                            <p className="font-mono text-[10px] uppercase tracking-wider text-zinc-500 mt-2">Scan to advertise</p>
                        </div>
                    </div>
                </div>
                <div className="bg-[#4C1D95] text-white px-12 py-4 flex items-center justify-between print:bg-[#4C1D95]">
                    <span className="font-mono text-[11px] uppercase tracking-wider">flexlines.store/advertise</span>
                    <span className="font-mono text-[11px] uppercase tracking-wider">Reach. Promote. Grow.</span>
                </div>
            </div>
        </div>
    );
}
